import { render, staticRenderFns } from "./AnnouncementDetails.vue?vue&type=template&id=160fa0d6&scoped=true"
import script from "./AnnouncementDetails.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementDetails.vue?vue&type=style&index=0&id=160fa0d6&prod&scoped=true&lang=scss"
import style1 from "./AnnouncementDetails.vue?vue&type=style&index=1&id=160fa0d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160fa0d6",
  null
  
)

export default component.exports